<template>
  <div>
    <div class="overlayMask"></div>
    <!-- @click="closePopup" -->
    <div class="salesgear-duplicate-contact-section">
      <div class="ae-popup-card popup-animate popup-scale-in">
        <div class="ae-title">
          <i class="material-icons closePopup" @click="closePopup">close</i>
          <img
            v-if="
              expContactType === 'duplicateSameUser' ||
                expContactType === 'sequenceDuplicateSameUser' ||
                expContactType === 'sequenceDuplicateDiffUser'
            "
            src="@/assets/icons/png/contactWarning.png"
            class="contact-img"
          />
          <img
            src="@/assets/icons/png/contactLock.png"
            v-if="expContactType === 'duplicateDiffUser'"
            class="contact-img"
          />
        </div>
        <div class="ae-popup-body">
          <h6
            class="ae-title"
            v-if="
              expContactType === 'duplicateSameUser' ||
                expContactType === 'sequenceDuplicateSameUser'
            "
          >
            This contact is already present in Salesgear.
          </h6>
          <h6
            class="ae-title"
            v-if="expContactType === 'sequenceDuplicateDiffUser'"
          >
            This contact is already exists in Salesgear and is owned by
            <span class="blue-text">{{ contactOwnerName }}</span>
          </h6>
          <h6 class="ae-title" v-if="expContactType === 'duplicateDiffUser'">
            Sorry, you cannot export this contact to Salesgear.
          </h6>
          <p class="ae-desc" v-if="expContactType === 'duplicateSameUser'">
            Would you like to update this contact?
          </p>
          <p
            class="ae-desc"
            v-if="expContactType === 'sequenceDuplicateSameUser'"
          >
            Would you like to update this contact and then add it to the
            sequence?
          </p>

          <p
            class="ae-desc"
            v-if="expContactType === 'sequenceDuplicateDiffUser'"
          >
            Would you still want to add it to the sequence?
          </p>
          <p class="ae-desc" v-if="expContactType === 'duplicateDiffUser'">
            This contact is already exists in Salesgear and is owned by
            <span class="blue-text">{{ contactOwnerName }}</span>
          </p>
        </div>
        <div
          class="ae-popup-footer"
          v-if="expContactType !== 'duplicateDiffUser'"
        >
          <div class="groupBtn">
            <button class="but primary-btn" @click="confirmPopup" type="button">
              Yes
            </button>
            <button class="but cancel-btn" @click="closePopup" type="button">
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import shareFunction from '@/assets/util/functions'
// import { MxEvent } from '@/assets/util/constants/analytics'

export default {
  name: 'SalesgearDuplicateContactPopup',
  components: {},
  props: [],
  data: function() {
    return {
      type: this.expContactType
    }
  },
  computed: {
    expContactType() {
      return this.$store.state.salesgear.expContactType
    },
    contactOwnerName() {
      return this.$store.state.salesgear.contactOwnerName
    }
  },
  methods: {
    closePopup() {
      this.$store.state.salesgear.isDupContact = false
    },
    confirmPopup() {
      this.$store.state.salesgear.isDupContact = false
      this.$emit('confirmExport')
    }
  }
}
</script>

<style scoped lang="scss">
.overlayMask {
  @include overlay(rgb(0, 0, 0, 0.85), 10, fixed);
}
.salesgear-duplicate-contact-section {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  will-change: transform;
  width: 84%;
  max-width: 360px;
  z-index: 11;
  margin: 0 auto;
  .ae-popup-card {
    background: $white;
    color: $text-dark;
    padding: 30px;
    border-radius: 6px;
    letter-spacing: 0.3px;
    transition: all 300ms ease;
    @include relBlock;
    will-change: auto;
    .ae-title {
      will-change: auto;
      @include relBlock;
      padding-top: 10px;
      i {
        position: absolute;
        right: -16px;
        top: -16px;
      }
      .contact-img {
        @include relBlock;
        width: 50px;
        height: 100%;
        will-change: width;
        margin: 0 auto;
      }
    }
    .ae-popup-body {
      @include relBlock;
      will-change: auto;
      padding: 20px 0;
      .ae-title {
        margin: 0;
        text-align: center;
        font-size: 18px;
        will-change: font-size;
        line-height: 1.4;
        padding-bottom: 23px;
        .blue-text {
          color: $primary-color;
        }
      }
      .ae-desc {
        margin: 0;
        text-align: center;
        font-size: 16px;
        will-change: font-size;
        line-height: 1.4;
        .blue-text {
          color: $primary-color;
        }
      }
    }
    .ae-popup-footer {
      @include relBlock;
      width: 100%;
      will-change: auto;
      .groupBtn {
        position: relative;
        margin: 10px 0px;
        width: 100%;
        @include flex-align-path-justify(center, row, space-evenly);
        .primary-btn,
        .cancel-btn {
          width: calc(50% - 15px);
          will-change: width;
          padding: 10px 14px;
          letter-spacing: 0.4px;
          font-size: 16px;
          border: 1px solid $primary-color;
          &:hover {
            box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.15);
          }
        }
        .cancel-btn {
          border: 1px solid $primary-color;
          will-change: inherit;
          color: $primary-color;
          background: $white;
        }
      }
    }
  }
}
</style>
